import { ApplicationConfig, ErrorHandler, LOCALE_ID, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { PeticionApiInterceptor } from './interceptor/peticion-api.interceptor';
import { sessionInterceptor } from './interceptor/session.interceptor';
import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { RECAPTCHA_V19_SITE_KEY } from 'recaptcha-v19';
import { peticionApiReportsInterceptor } from './interceptor/peticion-api-reports.interceptor';
import { peticionHistoryInterceptor } from 'interceptor/peticion-history.interceptor';
import { TsiErrorHandler } from 'errors/tsiErrorHandler';
import { CHATBOT_CONFIG } from './shared/ui/chatbot/chatbot.model';
import { ERP_CHATBOT_CONFIG } from './shared/ui/chatbot/chatbot-erp.config';
import { provideServiceWorker } from '@angular/service-worker';
import { TABS_SYNC_PROVIDER } from 'layout-tsi';
import { UsuarioTabsService } from '@shared/data-access/usuario-tabs.service';
import { provideVarianteGlobal } from 'ng-components-tsi';

registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
    provideVarianteGlobal('soft'),
    DatePipe, DecimalPipe,
  { provide: LOCALE_ID, useValue: 'es' },
  provideRouter(routes, withComponentInputBinding()),
  provideHttpClient(withInterceptors([peticionHistoryInterceptor, sessionInterceptor, PeticionApiInterceptor, peticionApiReportsInterceptor])),
  provideAnimationsAsync(),
  { provide: RECAPTCHA_V19_SITE_KEY, useValue: environment.recaptcha.siteKey },
  { provide: ErrorHandler, useClass: TsiErrorHandler },
  {
    provide: CHATBOT_CONFIG,
    useFactory: () => ({
      ...ERP_CHATBOT_CONFIG,
      primaryColor: environment.production ? '#1565C0' : '#c50048'
    })
  }, provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerImmediately'
          }),
  {
    provide: TABS_SYNC_PROVIDER,
    useFactory: (usuarioTabsService: UsuarioTabsService) => ({
      getAccess: () => usuarioTabsService.getAccess(),
      saveAccess: (payload: string) => usuarioTabsService.saveAccess(payload),
    }),
    deps: [UsuarioTabsService]
  },
  ]
}
